import { Divider } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import SummarizeIcon from '@mui/icons-material/Summarize';
import { IEntityContentField } from '../../../../lib/interfaces/Common';
import ContentTitleWithIcon from '../../../Simple/ContentTitle/ContentTitleWithIcon';
import ContentRenderer from '../../Content/ContentRenderer';

// import './Conclusion.scss';

type ConclusionProps = {
	field: IEntityContentField;
};

const Conclusion: FC<ConclusionProps> = ({ field }) => {
	const { t } = useTranslation();
	const title = field.options?.label || t('taskOverview');
	return (
		<div className="Conclusion">
			<div className="wrapper">
				<ContentTitleWithIcon id={field.id} content={title} icon={SummarizeIcon} />
				<Divider />
				<ContentRenderer html={field.content} key={field.name} />
			</div>
		</div>
	);
};

export default Conclusion;
